export default {
  beforeRouteLeave(to, from, next) {
    this.$coac.reset();
    next();
  },
};
